module.exports = __webpack_public_path__ + "Logoanimasjon_loop.gif?f47b58a3bed0948057355db3d0776615";